













































import { Vue, Component, Prop } from "vue-property-decorator";
import ExpressionOfInterest from "@/entity/ExpressionOfInterest";
import ProjectBuyersService from "@/services/ProjectBuyersService";
import ShareUrlDialog from "@/components/project-buyers/expression-of-interest/ShareUrlDialog.vue";
import Contact, { getContactFullName } from "@/entity/Contact";

@Component({
  components: {
    ShareUrlDialog,
  },
})
export default class ExpressionOfInterestVersions extends Vue {
  @Prop({ required: true, type: Number }) projectId!: number;
  @Prop({ required: true, type: Number }) buyerId!: number;
  @Prop({ required: true, type: Object }) contact!: Contact;

  showSkeleton = true;
  expressionsOfInterest: ExpressionOfInterest[] = [];
  shareUrlDialogOpened = false;
  shareUrl = "";

  async getEoiShareLink(eoi: ExpressionOfInterest): Promise<void> {
    const response = await ProjectBuyersService.getExpressionOfInterestLink(
      this.projectId,
      this.buyerId,
      eoi.id as number
    );
    this.shareUrl = response.url;
    this.shareUrlDialogOpened = true;
  }

  async loadExpressionsOfInterest(): Promise<void> {
    try {
      const response =
        await ProjectBuyersService.getAllBuyersExpressionsOfInterest(
          this.projectId,
          this.buyerId
        );

      this.expressionsOfInterest = response.reverse();
    } catch (error) {
      if (error.response.status !== 404) {
        throw error;
      }
    }
  }

  getUserName(eoi: ExpressionOfInterest): string {
    if (!eoi.user) {
      return getContactFullName(this.contact);
    }

    return eoi.user?.displayName ?? "";
  }

  async created() {
    await this.loadExpressionsOfInterest();
    this.showSkeleton = false;
  }
}
